/* 🤖 this file was generated by svg-to-ts */
export const matIconVerticalAlignCenter: {
  name: 'vertical-align-center';
  data: string;
} = {
  name: 'vertical-align-center',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"/></svg>`
};
